import axios from 'axios'

// Get all tickets from show date
const getAll = async (showDate) => {
  const { data } = await axios.get(`${process.env.VUE_APP_API}/ticket/${showDate}`)
  return data
}

// Get all tickets reserved from user
const getReserved = async () => {
  const { data } = await axios.get(`${process.env.VUE_APP_API}/ticket/customer/reserved`)
  return data
}

// Get all tickets from user and show date
const getByShowDate = async (showDate) => {
  const { data } = await axios.get(`${process.env.VUE_APP_API}/ticket/customer/${showDate}`)
  return data
}

// Get all tickets from user by transaction
const getByTransaction = async (id) => {
  const { data } = await axios.get(`${process.env.VUE_APP_API}/ticket/customer/transaction/${id}`)
  return data
}

// Reserve seats for customer
const reserve = async (showDate, seats, withSection) => {
  const { data } = await axios.post(`${process.env.VUE_APP_API}/ticket/customer`, {
    showDate,
    seats,
    withSection
  })
  return data
}

// Reserve tickets for customer (without stage)
const reserveWithoutStage = async (showDate, showPrices) => {
  const { data } = await axios.post(`${process.env.VUE_APP_API}/ticket/customer/without-stage`, {
    showDate,
    showPrices
  })
  return data
}

// Buy seats for customer
const buy = async (
  ids,
  showPrices,
  type,
  creditNumber = null,
  creditValidity = null,
  creditName = null,
  creditCVV = null,
  document = null,
  addressPostcode = null,
  addressState = null,
  addressCity = null,
  addressSuburb = null,
  addressStreet = null,
  addressNumber = null,
  addressAdjunct = null,
  saveCard = false,
  installments = 1
) => {
  const body = {
    ids,
    showPrices,
    type,
    document,
    addressPostcode,
    addressState,
    addressCity,
    addressSuburb,
    addressStreet,
    addressNumber,
    addressAdjunct,
    saveCard,
    installments
  }
  if (type === 'credit') {
    body.creditNumber = creditNumber ? creditNumber.replace(/ /g, '') : null
    body.creditValidity = creditValidity ? creditValidity.replace(/ /g, '') : null
    body.creditName = creditName ? creditName.toUpperCase() : null
    body.creditCVV = creditCVV
  }
  const { data } = await axios.put(`${process.env.VUE_APP_API}/ticket/customer`, body)
  return data
}

// Get amount of tickets available
const getAmountPrices = async (showDate) => {
  const { data } = await axios.get(`${process.env.VUE_APP_API}/ticket/${showDate}/amount`)
  return data
}

// Print ticket
const print = async (ids) => {
  const { data } = await axios.get(`${process.env.VUE_APP_API}/ticket/customer/print`, { params: {
    ids
  } })
  return data
}

// Cancel Ticket for customer
const cancelTicket = async (id, price) => {
  const { data } = await axios.post(`${process.env.VUE_APP_API}/ticket/customer/cancel`, {
    id,
    price
  })
  return data
}

// Transfer Ticket for customer
const transferTicket = async (id, transfer) => {
  const { data } = await axios.post(`${process.env.VUE_APP_API}/ticket/customer/transfer`, {
    id,
    transfer
  })
  return data
}

// Check Pix
const checkPix = async (pix) => {
  const { data } = await axios.post(`${process.env.VUE_APP_API}/signature/checkpix`, {
    pix
  })
  return data
}

// get Bank List
const getBanks = async () => {
  const { data } = await axios.get(`${process.env.VUE_APP_API}/admin/banks`, {

  })
  return data
}

// Refund Ticket Billet
const refundBillet = async (bankCode, agency, agencyDg, account, accountDg, accountType, document, name, id, price) => {
  const { data } = await axios.post(`${process.env.VUE_APP_API}/ticket/customer/refund-billet`, {
    bankCode,
    agency,
    agencyDg,
    account,
    accountDg,
    accountType,
    document,
    name,
    id,
    price
  })
  return data
}

export {
  getAll,
  getReserved,
  getByShowDate,
  reserve,
  reserveWithoutStage,
  buy,
  getAmountPrices,
  print,
  cancelTicket,
  transferTicket,
  checkPix,
  getBanks,
  refundBillet,
  getByTransaction
}
